import { arrayOf, bool, number, shape, string } from 'prop-types'

// Taken from the Carrier Service Contract bully
export const shippingServiceType = arrayOf(
  shape({
    id: string.isRequired,
    group: string.isRequired,
    displayName: string.isRequired,
    shippingMethod: string.isRequired,
    neighbourDeliveryProhibitable: bool.isRequired,
    relativeImageUrl: string.isRequired,
    trackingLink: string.isRequired,
    currency: string.isRequired,
    shippingCost: number.isRequired,
    freeShippingThreshold: number,
    freeShippingMargin: number,
    defaultDeliveryTimeMin: number.isRequired,
    defaultDeliveryTimeMax: number.isRequired,
    latestDeliveryDate: string.isRequired,
    deliveryTimeMinAvailableUntil: string,
    pickupStationDeliverySupported: bool.isRequired,
  })
)
